import React, {Component} from 'react';
import {Checkbox, FormControlLabel, TextField, Select, MenuItem, Modal, CircularProgress} from "@material-ui/core";
import {withStyles} from '@material-ui/core/styles';
import _ from 'lodash';
import validator from 'validator';
import * as API from './apiGateway';

const INITIAL_FORM_STATE = {
    fullName: '',
    prefix: '',
    phone: '',
    carNumber: '',
    email: '',
    gender: "NOT_DEFINED",
    approveAds: false,
    acceptRules: false,
};

const ERROR_CODES = {
    '1000': 'כתובת המייל כבר בשימוש'
};

class SignupForm extends Component {
    state = {
        ...INITIAL_FORM_STATE,
        showRules: false,
        errors: {},
        sendError: false,
        formSent: false,
        sendingForm: false
    };

    componentDidMount() {
        this._initializePhone();
    }

    render() {
        const {classes} = this.props;
        const {fullName, phone, carNumber, email, gender, approveAds, acceptRules, errors, prefix, formSent, sendError, sendingForm, showRules} = this.state;

        return (
            <form className="main-form mx-auto text-right" autoComplete="off">
                <TextField
                    id="fullName"
                    label="שם מלא"
                    error={!_.isEmpty(errors.fullName)}
                    helperText={errors.fullName}
                    value={fullName}
                    onChange={this._handleChange('fullName')}
                    margin="normal"
                    fullWidth/>
                <div className="flex items-baseline justify-between"><TextField
                    id="phone"
                    label="טלפון"
                    type="tel"
                    value={phone}
                    inputProps={{maxLength: 7}}
                    error={!_.isEmpty(errors.phone)}
                    helperText={errors.phone}
                    onChange={this._handleChange('phone')}
                    margin="normal"/>
                    <Select
                        value={prefix}
                        onChange={this._handleChange('prefix')}
                        name="prefix"
                        error={errors.prefix}>
                        <MenuItem value={'050'}>050</MenuItem>
                        <MenuItem value={'051'}>051</MenuItem>
                        <MenuItem value={'052'}>052</MenuItem>
                        <MenuItem value={'053'}>053</MenuItem>
                        <MenuItem value={'054'}>054</MenuItem>
                        <MenuItem value={'055'}>055</MenuItem>
                        <MenuItem value={'056'}>056</MenuItem>
                        <MenuItem value={'058'}>058</MenuItem>
                        <MenuItem value={'059'}>059</MenuItem>
                    </Select>
                </div>
                <TextField
                    id="carNumber"
                    label="מספר רכב"
                    type="tel"
                    inputProps={{maxLength: 8}}
                    value={carNumber}
                    error={!_.isEmpty(errors.carNumber)}
                    helperText={errors.carNumber}
                    onChange={this._handleChange('carNumber')}
                    margin="normal"
                    fullWidth/>
                <TextField
                    id="email"
                    label="מייל"
                    value={email}
                    error={!_.isEmpty(errors.email)}
                    helperText={errors.email}
                    onChange={this._handleChange('email')}
                    margin="normal"
                    fullWidth/>
                <div className="pick-gender">
                    <FormControlLabel control={
                        <Checkbox color="default" checked={gender === "MALE"}
                                  onClick={() => this.setState({gender: "MALE"})}/>
                    } label="זכר"/>
                    <FormControlLabel control={<Checkbox color="default" checked={gender === "FEMALE"}
                                                         onClick={() => this.setState({gender: "FEMALE"})}/>}
                                      label="נקבה"/>
                    <FormControlLabel control={<Checkbox color="default" checked={gender === "NOT_DEFINED"}
                                                         onClick={() => this.setState({gender: "NOT_DEFINED"})}/>}
                                      label="לא מגדיר"/>
                </div>
                <FormControlLabel
                    control={<Checkbox color="default" onClick={() => this.setState({approveAds: !approveAds})}
                                       checked={approveAds}/>}
                    label="אישור פרסום"/>
                <div className="underline-rules"><FormControlLabel
                    onClick={() => acceptRules ? this.setState({acceptRules: false}) : this.setState({showRules: true})}
                    control={<Checkbox className={errors.acceptRules && classes.error} color="default"
                                       checked={acceptRules}/>}
                    label="אישור תקנון"/></div>
                <div onClick={this._handleSubmit} className="confirm-button text-center mx-auto">
                    {sendingForm ? <CircularProgress className="confirm-text" size={18} color="secondary"/> :
                        <div className="confirm-text">אישור</div>}
                </div>
                {sendError &&
                <div className="form-sending-failed text-center">{sendError}</div>}

                <Modal
                    open={showRules}
                    onClose={() => this.setState({showRules: false})}>
                    <div>
                        <div className="form-sent mx-auto">
                            <p className="form-sent-header mx-auto text-center">תקנון</p>
                            <div className="form-sent-button text-center mx-auto"
                                 onClick={() => this.setState({showRules: false, acceptRules: true})}>
                                <p className="form-sent-text">מאשר</p>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    open={formSent}
                    onClose={() => this.setState({sent: false})}>
                    <div>
                        <div className="form-sent mx-auto">
                            <p className="form-sent-header mx-auto text-center">הטופס נשלח בהצלחה!</p>
                            <div className="form-sent-button text-center mx-auto"
                                 onClick={() => this.setState({formSent: false})}>
                                <p className="form-sent-text">איזה כיף לי</p>
                            </div>
                        </div>
                    </div>
                </Modal>
            </form>
        );
    }

    _initializePhone() {
        const params = new URL(document.location).searchParams;
        let prefix = '', phone = '';
        if (params.get("phone")) {
            const userPhone = params.get("phone");
            prefix = userPhone.slice(0, 3);
            phone = userPhone.slice(3, 11);
        }
        this.setState({prefix, phone});
    }

    _handleSubmit = async () => {
        if (this._validateForm()) {
            this.setState({sendingForm: true, sendError: null});
            const {fullName, phone, prefix, carNumber, email, gender, approveAds} = this.state;
            const userInfo = {
                "carNumber": carNumber,
                "email": email,
                "phoneNumber": prefix + phone,
                "fullName": fullName,
                "gender": gender,
                "approvesAds": approveAds
            };
            try {
                await API.registerNewUser(userInfo);
                this.setState({
                    ...INITIAL_FORM_STATE,
                    formSent: true,
                    sendingForm: false
                })
            }
            catch (err) {
                let errorMessage = this.getErrorMessage(err);
                this.setState({sendError: errorMessage, sendingForm: false})
            }
        }
    };

    getErrorMessage(err) {
        let errorMessage = 'השליחה נכשלה, נסה במועד מאוחר יותר';
        const serverErrorCode = _.get(err, 'response.data.ErrorCode');

        if (serverErrorCode && parseInt(serverErrorCode, 10)) {
            errorMessage = ERROR_CODES[serverErrorCode] || errorMessage;
        }
        return errorMessage;
    }

    _handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    _validateForm = () => {
        let errors = {};
        const {fullName, phone, carNumber, email, acceptRules, prefix} = this.state;
        if (!/^[\u0590-\u05FF-]{2,15} ([\u0590-\u05FF-]{2,15} ?){1,3}$/.test(fullName)) {
            errors.fullName = "נא להזין שם מלא בעברית"
        }
        if (!validator.isNumeric(prefix) || !validator.isLength(prefix, {min: 3, max: 3})) {
            errors.prefix = true;
            errors.phone = "נא להזין מספר טלפון תקין"
        }
        if (!validator.isNumeric(phone) || !validator.isLength(phone, {min: 7, max: 7})) {
            errors.phone = "נא להזין מספר טלפון תקין"
        }
        if (!validator.isNumeric(carNumber) || !validator.isLength(carNumber, {min: 7, max: 8})) {
            errors.carNumber = "נא להזין מספר רכב תקין"
        }
        if (!validator.isEmail(email)) {
            errors.email = "נא להזין מייל תקין"
        }
        if (!acceptRules) {
            errors.acceptRules = true
        }

        this.setState({errors});
        return _.isEmpty(errors);
    };
}

const styles = {
    error: {
        color: "red"
    }
};

export default withStyles(styles)(SignupForm);



// WEBPACK FOOTER //
// ./src/SignupForm.js